"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitAssertRequest = exports.splitAssertAnyRequest = exports.mergeAssertResponses = exports.mergeAssertAnyResponses = exports.assertionError = exports.assertionAnyError = exports.TokenRequestBuilder = exports.AssertRequestBuilder = exports.AssertAnyRequestBuilder = void 0;
var _ = require("..");
var _util = require("../util");
var _constants = require("./constants");
let AssertRequestBuilder = exports.AssertRequestBuilder = void 0;
(function (_AssertRequestBuilder) {
  const init = args => ({
    assertion_type: args.assertion_type ?? "",
    token: args.token ?? "",
    token_scope: args.token_scope ?? "",
    token_feature_scope: args.token_feature_scope ?? "",
    token_client_application_scope: args.token_client_application_scope ?? "",
    scope: args.scope ?? "",
    feature_scope: args.feature_scope ?? "",
    client_application_scope: args.client_application_scope ?? "",
    client_application_id: args.client_application_id ?? ""
  });
  const token = _AssertRequestBuilder.token = args => init({
    assertion_type: "token",
    ...args
  });
  const tokenScope = _AssertRequestBuilder.tokenScope = args => init({
    assertion_type: "token_scope",
    ...args
  });
})(AssertRequestBuilder || (exports.AssertRequestBuilder = AssertRequestBuilder = {}));
const assertionError = (req, res) => {
  const missing = Object.entries({
    scope: res.missing_scope,
    feature_scope: res.missing_feature_scope,
    client_application_scope: res.missing_client_application_scope
  }).filter(([, v]) => !!v).reduce((keys, [key]) => {
    keys.push(key);
    return keys;
  }, []);
  return new _.InsufficientScope(`missing ${missing.join(",")}`, (0, _.filterCredentialsFromObject)(res), {
    client_application_id: req.client_application_id,
    client_application_scope: req.client_application_scope,
    feature_scope: req.feature_scope,
    scope: req.scope
  });
};
exports.assertionError = assertionError;
let AssertAnyRequestBuilder = exports.AssertAnyRequestBuilder = void 0;
(function (_AssertAnyRequestBuilder) {
  const init = args => ({
    assertion_type: args.assertion_type ?? "",
    token: args.token ?? "",
    token_scope: args.token_scope ?? "",
    token_feature_scope: args.token_feature_scope ?? "",
    token_client_application_scope: args.token_client_application_scope ?? "",
    items: args.items ?? []
  });
  const initItem = args => ({
    scope: args.scope ?? "",
    feature_scope: args.feature_scope ?? "",
    client_application_scope: args.client_application_scope ?? "",
    client_application_id: args.client_application_id ?? ""
  });
  const tokenAnyScope = _AssertAnyRequestBuilder.tokenAnyScope = args => {
    const items = args.any_scope.map(scope => initItem({
      scope,
      ...args
    }));
    return init({
      assertion_type: "token",
      items,
      ...args
    });
  };
  const tokenScopeAnyScope = _AssertAnyRequestBuilder.tokenScopeAnyScope = args => {
    const items = args.any_scope.map(scope => initItem({
      scope,
      ...args
    }));
    return init({
      assertion_type: "token_scope",
      items,
      ...args
    });
  };
})(AssertAnyRequestBuilder || (exports.AssertAnyRequestBuilder = AssertAnyRequestBuilder = {}));
const assertionAnyError = (req, res) => new _.InsufficientScope(`missing any permissions: ${JSON.stringify(req.items)}`, (0, _.filterCredentialsFromObject)(res), {
  client_application_scope: "",
  feature_scope: "",
  scope: "",
  client_application_id: ""
});
exports.assertionAnyError = assertionAnyError;
let TokenRequestBuilder = exports.TokenRequestBuilder = void 0;
(function (_TokenRequestBuilder) {
  const init = args => ({
    grant_type: args.grant_type ?? "",
    scope: args.scope ?? "",
    assertion: args.assertion ?? "",
    refresh_token: args.refresh_token ?? "",
    client_id: args.client_id ?? "",
    client_secret: args.client_secret ?? "",
    client_assertion: args.client_assertion ?? "",
    client_assertion_type: args.client_assertion_type ?? "",
    subject_token: args.subject_token ?? "",
    subject_token_type: args.subject_token_type ?? ""
  });
  const accessTokenExchange = _TokenRequestBuilder.accessTokenExchange = args => init(args);
  const idTokenExchange = _TokenRequestBuilder.idTokenExchange = async args => init({
    grant_type: "urn:ietf:params:oauth:grant-type:token-exchange",
    scope: args.scope,
    subject_token: await args.get_id_token(),
    subject_token_type: "urn:ietf:params:oauth:token-type:id_token"
  });
  const refreshToken = _TokenRequestBuilder.refreshToken = args => init({
    grant_type: "refresh_token",
    ...args
  });
  const clientCredential = _TokenRequestBuilder.clientCredential = args => {
    return init({
      grant_type: "client_credentials",
      client_assertion_type: "urn:ietf:params:oauth:client-assertion-type:jwt-bearer",
      ...args
    });
  };
})(TokenRequestBuilder || (exports.TokenRequestBuilder = TokenRequestBuilder = {}));
const splitAssertRequest = req => {
  const items = ["scope", "feature_scope"];
  const maxItemLength = items.reduce((acc, cur) => {
    const item = req[cur].split(" ");
    return acc > item.length ? acc : item.length;
  }, 0);
  const repeatCount = Math.ceil(maxItemLength / _constants.MAX_SCOPE_COUNT);
  return [...Array(repeatCount).keys()].map(index => {
    var _req$scope$split$slic, _req$feature_scope$sp;
    const _req = {
      ...req
    };
    _req.scope = ((_req$scope$split$slic = req.scope.split(" ").slice(index * _constants.MAX_SCOPE_COUNT, (index + 1) * _constants.MAX_SCOPE_COUNT)) === null || _req$scope$split$slic === void 0 ? void 0 : _req$scope$split$slic.join(" ")) || "";
    _req.feature_scope = ((_req$feature_scope$sp = req.feature_scope.split(" ").slice(index * _constants.MAX_SCOPE_COUNT, (index + 1) * _constants.MAX_SCOPE_COUNT)) === null || _req$feature_scope$sp === void 0 ? void 0 : _req$feature_scope$sp.join(" ")) || "";
    return _req;
  });
};
exports.splitAssertRequest = splitAssertRequest;
const splitAssertAnyRequest = req => {
  const maxItemLength = req.items.length;
  const repeatCount = Math.ceil(maxItemLength / _constants.MAX_ITEM_COUNT);
  const chunkItems = (0, _util.chunk)(req.items, _constants.MAX_ITEM_COUNT);
  return [...Array(repeatCount).keys()].map(index => ({
    ...req,
    items: chunkItems[index]
  }));
};
exports.splitAssertAnyRequest = splitAssertAnyRequest;
const mergeAssertResponses = responses => {
  return responses.reduce((acc, cur) => {
    return {
      ...cur,
      scope: [acc.scope, cur.scope].filter(Boolean).join(" "),
      feature_scope: [acc.feature_scope, cur.feature_scope].filter(Boolean).join(" ")
    };
  });
};
exports.mergeAssertResponses = mergeAssertResponses;
const mergeAssertAnyResponses = responses => {
  return responses.reduce((acc, cur, index) => {
    if (index === 0) return cur;
    let is_active_token;
    if (acc.is_active_token === undefined) {
      is_active_token = cur.is_active_token;
    } else if (!acc.is_active_token) {
      is_active_token = false;
    } else if (acc.is_active_token && cur.is_active_token) {
      is_active_token = true;
    }
    return {
      result: (cur === null || cur === void 0 ? void 0 : cur.result) && (acc === null || acc === void 0 ? void 0 : acc.result),
      ...(is_active_token !== undefined && {
        is_active_token
      })
    };
  });
};
exports.mergeAssertAnyResponses = mergeAssertAnyResponses;
//# sourceMappingURL=TokenService.js.map